import React, { useEffect, useState } from 'react';
import CountUp from 'react-countup';

export default function AnimatedCount({ end, duration = 2, suffix = '' }) {
  const [key, setKey] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setKey((prev) => prev + 1); // This will remount CountUp
    }, 6000); // Change count every 6 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <CountUp key={key} start={0} end={end} duration={duration} suffix={suffix} />
  );
}
